import { useIntl } from "react-intl";

const IncidentCreation = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.IncidentCreation.header",
            defaultMessage: "Incident creation"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.IncidentCreation.body",
            defaultMessage:
                "Using templates, incident responders are automatically notified as soon as the incident occurs."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default IncidentCreation;
